function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function refreshScrollAnimationTrigger(newPostIds) {
  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  let newAnimationTriggerElements = [];
  newPostIds.forEach((id) => {
    animationTriggerElements.forEach((element) => {
      if (element.dataset.id == id) {
        newAnimationTriggerElements.push(element);
      }
    })
  })

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  newAnimationTriggerElements.forEach((element) => observer.observe(element));
}

if (!customElements.get('infinite-scroll')) {
  customElements.define(
    'infinite-scroll',
    class InfiniteScroll extends HTMLElement {
      constructor() {
        super();
      }

      handleEndReach(entries, observer) {
          entries.forEach(async (entry) => {
            if (entry.isIntersecting) {
              if (this.currPage < this.numPages) {
                const path = window.location.href.split('?page=')[0] + '?page=' + (this.currPage + 1);

                const response = await fetch(path, {
                  headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                  }
                });
                const responseText = await response.text();

                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const newPostEles = html.querySelector('infinite-scroll').children;
                const newPostIds = Array.from(newPostEles).map(newPost => newPost.dataset.id);
                this.append(...newPostEles);

                refreshScrollAnimationTrigger(newPostIds);

                this.currPage = this.currPage + 1;
              }
            }
          })
      }

      connectedCallback() {
        this.hasReachedStart = false;
        if (Number(window.location.href.split('page=')[1])) {
          this.currPage = Number(window.location.href.split('page=')[1]);
        } else {
          this.currPage = 1;
        }
        this.numPages = this.dataset.numPages;

        this.bottomObserver = new IntersectionObserver(this.handleEndReach.bind(this), {
          rootMargin: '0% 0% 0% 0%', 
          threshold: 0
        });
        this.bottomObserver.observe(document.querySelector('footer'));
      }

      disconnectedCallback() {
        this.bottomObserver.disconnect();
      }
    }
  );
}